// File: frontend/src/components/layout/PageContainer.js

import React from 'react';
import styles from './PageContainer.module.css';

const PageContainer = ({ children, maxWidth = '1280px' }) => {
  return (
    <div className={styles.pageContainer} style={{ maxWidth }}>
      {children}
    </div>
  );
};

export default PageContainer;